import { GridPerformanceInsight } from './grid.pi.component';

export default {
    'cmps-performance-insight-grid': GridPerformanceInsight,
};
